var a={DAY:"day",MONTH:"month",YEAR:"year"},r={day:!1,month:!1,year:!1};export{a as DateKey,r as defaultErrors};
//# sourceMappingURL=types.js.map
